import Icon from '@jetbrains/ring-ui-built/components/icon'
import cn from 'classnames'

import LoaderIcon from './pie-chart.svg'

import styles from './Loader.module.css'

type LoaderProps = {
	className?: string
}

export function Loader({ className }: LoaderProps) {
	return <Icon glyph={LoaderIcon} className={cn(className, styles.pieChart)} />
}
